export const handleChangeDataPageProductDetails = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_PRODUCT_DETAILS', name, value
});